<div class="zwi-main__content">
  <div class="zwi-content__wrapper">
    <div class="zwi-section">
      <zwi-back-headline (navigateBack)="navigateToSettings()">Profile Image</zwi-back-headline>
      <zwi-profile-image-form></zwi-profile-image-form>
    </div>
  </div>
</div>
